"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var horizontal_drag_scroll_1 = __importDefault(require("../../shared-components/horizontal-drag-scroll"));
var progress_to_shipping_threshold_bar_1 = __importDefault(require("../../shared-components/progress-to-shipping-threshold-bar"));
var quantity_picker_1 = __importDefault(require("../components/quantity-picker"));
var variant_details_modal_1 = __importDefault(require("../components/variant-details-modal"));
var bundle_1 = require("../store/bundle");
var calculations_1 = require("../utils/calculations");
var scrolling_1 = require("../utils/scrolling");
var ProductCard = function (_a) {
    var _b;
    var item = _a.item, selected = _a.selected, onIncrement = _a.onIncrement, onDecrement = _a.onDecrement, quantity = _a.quantity, className = _a.className, imageContainerClassName = _a.imageContainerClassName, onClickMagnifier = _a.onClickMagnifier, width = _a.width;
    var approximateQuantityPickerHeight = 34;
    return (
    // padding allows for top right icon so that we don't have to make it expand outside of this product card
    react_1.default.createElement("div", { className: (0, classnames_1.default)('position-relative', className), style: { width: width, userSelect: 'none', paddingTop: 5, paddingRight: 5 } },
        react_1.default.createElement("a", { className: 'position-absolute top-0 right-0', style: { height: 30, width: 30 }, onClick: onClickMagnifier },
            react_1.default.createElement("i", { className: 'ss-zoomin bundler-v2-patterns--zoomin-icon position-absolute circle text-wisteria border-wisteria text-lg width-100 height-100 bg-white flex-container align-center align-middle', style: { borderStyle: 'solid', borderWidth: 1 } })),
        react_1.default.createElement("div", { className: 'height-100', style: { display: 'grid', gridTemplateRows: 'min-content auto', gridTemplateColumns: '1fr' } },
            react_1.default.createElement("div", { className: 'flex-container align-bottom', style: { gridArea: '1 / 1 / 2 / 2' } },
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: -approximateQuantityPickerHeight / 2 + 1 } },
                    react_1.default.createElement("div", { className: 'flex-container align-center position-relative' },
                        react_1.default.createElement("div", { style: { width: '70%' } },
                            react_1.default.createElement(quantity_picker_1.default, { quantity: quantity, increase: onIncrement, decrease: onDecrement }))))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(imageContainerClassName, 'rounded-lg overflow-hidden', selected ? 'border-wisteria' : 'border-brownish-grey'), style: { gridArea: '1 / 1 / 2 / 2', height: width, aspectRatio: width ? undefined : '1/1', borderWidth: selected ? 3 : 1, borderStyle: 'solid' }, onClick: onIncrement }, ((_b = item.variant.featuredImage) === null || _b === void 0 ? void 0 : _b.src) && (react_1.default.createElement("img", { className: 'height-100 width-100 object-fit-cover', src: item.variant.featuredImage.src, alt: item.variant.featuredImage.alt, draggable: false, style: { pointerEvents: 'none', userSelect: 'none' } }))),
            react_1.default.createElement("div", { style: { gridArea: '2 / 1 / 3 / 2' } },
                react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify height-100' },
                    react_1.default.createElement("div", { className: 'text-sm', style: { marginTop: 20 } }, item.product.title),
                    react_1.default.createElement("div", { className: 'text-sm' },
                        react_1.default.createElement("span", { className: 'strike text-gray' },
                            "$",
                            item.variant.compareAtPrice),
                        "\u00A0\u00A0$",
                        item.variant.price))))));
};
var onIncrementAddonQuantity = function (addon, addons, changeAddons) {
    var e_1, _a;
    // shallow clone addon so that we can modify the primitive quantity property
    var newAddons = addons.map(function (a) { return (__assign({}, a)); });
    try {
        // first try to increment the quantity if we already have this addon
        for (var newAddons_1 = __values(newAddons), newAddons_1_1 = newAddons_1.next(); !newAddons_1_1.done; newAddons_1_1 = newAddons_1.next()) {
            var newAddon = newAddons_1_1.value;
            if (addon.variant.id === newAddon.variant.id) {
                newAddon.quantity += 1;
                changeAddons(newAddons);
                return;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (newAddons_1_1 && !newAddons_1_1.done && (_a = newAddons_1.return)) _a.call(newAddons_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // if we don't have this addon selected yet, add it
    newAddons.push({ variant: addon.variant, product: addon.product, quantity: 1 });
    changeAddons(newAddons);
};
var onDecrementAddonQuantity = function (addon, addons, changeAddons) {
    var e_2, _a;
    // shallow clone addon so that we can modify the primitive quantity property
    var newAddons = addons.map(function (a) { return (__assign({}, a)); });
    try {
        // decrement quantity of the given addon
        for (var newAddons_2 = __values(newAddons), newAddons_2_1 = newAddons_2.next(); !newAddons_2_1.done; newAddons_2_1 = newAddons_2.next()) {
            var newAddon = newAddons_2_1.value;
            if (addon.variant.id === newAddon.variant.id) {
                newAddon.quantity -= 1;
                // if we now have 0 quantity of this addon, just remove it
                if (newAddon.quantity === 0) {
                    newAddons = newAddons.filter(function (p) { return p.variant.id !== addon.variant.id; });
                }
                changeAddons(newAddons);
                return;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (newAddons_2_1 && !newAddons_2_1.done && (_a = newAddons_2.return)) _a.call(newAddons_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
/** Build an event with the same shape and values as what the v1 diaper bundler emits */
var buildArrivedAtStepEvent = function (selectedPatterns) {
    var e_3, _a;
    var patterns = new Set();
    try {
        for (var selectedPatterns_1 = __values(selectedPatterns), selectedPatterns_1_1 = selectedPatterns_1.next(); !selectedPatterns_1_1.done; selectedPatterns_1_1 = selectedPatterns_1.next()) {
            var selectedPattern = selectedPatterns_1_1.value;
            if (selectedPattern.variant.option2)
                patterns.add(selectedPattern.variant.option2);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (selectedPatterns_1_1 && !selectedPatterns_1_1.done && (_a = selectedPatterns_1.return)) _a.call(selectedPatterns_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var event = { event: 'diaperBundle__discountAddOns', selectedPatterns: __spreadArray([], __read(patterns), false) };
    return event;
};
var DiscountAddons = function (_a) {
    var navBar = _a.navBar, settings = _a.settings;
    var useBundleStore = (0, bundle_1.getBundleStore)().useBundleStore;
    var buildAvailableDiscountAddonGroups = useBundleStore(function (state) { return state.buildAvailableDiscountAddonGroups; });
    var selectedDiscountAddons = useBundleStore(function (state) { return state.selectedDiscountAddons; });
    var changeSelectedDiscountAddons = useBundleStore(function (state) { return state.changeSelectedDiscountAddons; });
    var products = useBundleStore(function (state) { return state.products; });
    var selectedPatterns = useBundleStore(function (state) { return state.selectedPatterns; });
    var selectedMainVariant = useBundleStore(function (state) { return state.selectedMainVariant; });
    var _b = __read((0, react_1.useState)(undefined), 2), openModalItem = _b[0], setOpenModalItem = _b[1];
    var handleSetOpenModalVariant = function (variant) {
        var shopifyProduct = products === null || products === void 0 ? void 0 : products.find(function (p) { return p.variants.some(function (v) { return v.id === variant.id; }); });
        if (shopifyProduct)
            setOpenModalItem({ product: shopifyProduct, variant: variant });
    };
    // Instantly scroll to top. This is necessary because we share the page's scrollbar between all of the steps
    // and we want the user to start at the top of each step.
    var hasPerformedInitialScrollToTop = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!hasPerformedInitialScrollToTop.current) {
            (0, scrolling_1.performInstantScroll)(window, { top: 0 });
            hasPerformedInitialScrollToTop.current = true;
        }
    });
    var hasEmittedDataLayerEvent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!hasEmittedDataLayerEvent.current) {
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(buildArrivedAtStepEvent(selectedPatterns));
            hasEmittedDataLayerEvent.current = true;
        }
    });
    var displayGroups = (0, react_1.useMemo)(function () {
        return buildAvailableDiscountAddonGroups() || [];
    }, [buildAvailableDiscountAddonGroups]);
    var productCardWidth = 128;
    var bundleSubtotal = (0, react_1.useMemo)(function () {
        return selectedMainVariant ? (0, calculations_1.calculateBundleSubtotal)(selectedMainVariant, selectedDiscountAddons, selectedPatterns) : 0;
    }, [selectedMainVariant, selectedDiscountAddons, selectedPatterns]);
    var freeShippingProgressBarProps = {
        phases: [{ achievedText: 'FREE shipping', notYetText: 'FREE shipping', color: '#a05eb5', outOfDollars: 75, shippingPrice: 4.99 }],
        currentValueDollars: bundleSubtotal,
        tooltipText: 'Excludes Alaska, Hawaii, & Canada',
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", { className: 'padding-horizontal-6 space-y-2' },
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-2xl', style: { fontWeight: 600 } }, "Add Extras Now and Save 15%!")),
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-almost-black' }, "You can add on up to 5 more products and get 15% off (vs. purchasing individually)."))),
        settings.enableProgressToFreeShippingBar && (react_1.default.createElement("div", { className: 'bundler-v2-patterns--sticky-top-section padding-horizontal-6 z15 bg-white' },
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'width-100 flex-container align-center' },
                react_1.default.createElement("div", { className: 'width-100', style: { maxWidth: 450 } },
                    react_1.default.createElement(progress_to_shipping_threshold_bar_1.default, __assign({}, freeShippingProgressBarProps)))),
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'border-very-light-pink', style: { borderTopWidth: 1, borderTopStyle: 'solid' } }))),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", { className: 'padding-left-6' },
            react_1.default.createElement("div", { className: 'space-y-4' }, displayGroups.map(function (group) { return (react_1.default.createElement("div", { key: group.displayName },
                react_1.default.createElement("div", { className: 'text-xl' }, group.displayName),
                react_1.default.createElement("div", { className: 'h-2' }),
                group.displayType === 'horizontalScroll' ? (react_1.default.createElement(horizontal_drag_scroll_1.default, { className: 'horizontal-drag-scroll--container padding-right-6 space-x-4 hide-scrollbar cursor-grab-grabbing' }, group.items.map(function (item) {
                    var addon = selectedDiscountAddons.find(function (p) { return p.variant.id === item.variant.id; });
                    return (react_1.default.createElement(ProductCard, { key: "".concat(item.variant.id, "-").concat(item.product.selectedSku), className: 'horizontal-drag-scroll--item', width: productCardWidth, item: item, selected: !!addon, quantity: (addon === null || addon === void 0 ? void 0 : addon.quantity) || 0, onIncrement: function () { return onIncrementAddonQuantity(item, selectedDiscountAddons, changeSelectedDiscountAddons); }, onDecrement: function () { return onDecrementAddonQuantity(item, selectedDiscountAddons, changeSelectedDiscountAddons); }, onClickMagnifier: function () { return handleSetOpenModalVariant(item.variant); } }));
                }))) : (react_1.default.createElement("div", { className: 'bundler-v2-index--product-card-grid padding-right-6' }, group.items.map(function (item) {
                    var addon = selectedDiscountAddons.find(function (p) { return p.variant.id === item.variant.id; });
                    return (
                    // Here we avoid providing a fixed width so that the product card can expand to fill the available grid space.
                    // Note that this makes the grid items a different size from the horizontal scroll items at most window widths.
                    react_1.default.createElement(ProductCard, { key: "".concat(item.variant.id, "-").concat(item.product.selectedSku), imageContainerClassName: 'cursor-pointer', item: item, selected: !!addon, quantity: (addon === null || addon === void 0 ? void 0 : addon.quantity) || 0, onIncrement: function () { return onIncrementAddonQuantity(item, selectedDiscountAddons, changeSelectedDiscountAddons); }, onDecrement: function () { return onDecrementAddonQuantity(item, selectedDiscountAddons, changeSelectedDiscountAddons); }, onClickMagnifier: function () { return handleSetOpenModalVariant(item.variant); } }));
                }))))); }))),
        navBar({ backButtonEnabled: true, nextButtonEnabled: true }),
        openModalItem && (react_1.default.createElement(variant_details_modal_1.default, { item: openModalItem, handleCloseModalClick: function () { return setOpenModalItem(undefined); }, isDiscount: true, handleIncreaseClick: function () {
                var addon = (function () {
                    var e_4, _a, e_5, _b;
                    try {
                        for (var displayGroups_1 = __values(displayGroups), displayGroups_1_1 = displayGroups_1.next(); !displayGroups_1_1.done; displayGroups_1_1 = displayGroups_1.next()) {
                            var group = displayGroups_1_1.value;
                            try {
                                for (var _c = (e_5 = void 0, __values(group.items)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var item = _d.value;
                                    if (item.variant.id === openModalItem.variant.id)
                                        return item;
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (displayGroups_1_1 && !displayGroups_1_1.done && (_a = displayGroups_1.return)) _a.call(displayGroups_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    throw new Error('Encountered coding bug while trying to look up addon');
                })();
                onIncrementAddonQuantity(addon, selectedDiscountAddons, changeSelectedDiscountAddons);
            } }))));
};
exports.default = DiscountAddons;
